import React from 'react'
import { I18n } from '@front/volcanion'

import { Box, Typography, StepLabel, StepContent } from '@mui/material'

import VoucherForm from '@abra/frames/Voucher'

const PrimarySection = () => <>
  <StepLabel>
    <Typography variant='h5'>{I18n.t('voucher.label')}</Typography>
  </StepLabel>
  <StepContent>
    <Box sx={{ borderRadius: 3, boxShadow: 6, p: 2, mb: 1 }}>
      <VoucherForm />
    </Box>
  </StepContent>
</>

export default React.memo(PrimarySection)
